import axios from 'axios';
import baseAPI from '@/api/base';
import { RECORD_EXPORT_URL } from '@/utils/urls';

export interface RecordExport {
  /** The kind of record exported, as the API names it: Announcement, Donation, ShiureiTorah. */
  entityType: string;
  /** Rows in the file. */
  count: number;
  format?: 'csv';
  /** The date range picked (YYYY-MM-DD), if any. */
  from?: string | null;
  to?: string | null;
}

class ActivityLog {
  // Exports are built in the browser, so the API only hears of one from here,
  // for the organization's activity log. Sent outside baseAPI's handlers: a
  // failure must never toast or interrupt the export the person just made.
  static recordExport = async (payload: RecordExport, sessionToken: string): Promise<void> => {
    try {
      await axios.post(RECORD_EXPORT_URL, payload, {
        baseURL: baseAPI.defaults.baseURL,
        headers: { Authorization: `Bearer ${sessionToken}` },
        timeout: 10000,
      });
    } catch (error) {
      // The file is already downloaded; nothing more to do.
    }
  };
}

export default ActivityLog;
